import { Component, effect, inject, signal, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { selectUserCredits } from '../../../../store/selectors/credits.selectors';
import { selectIsSubscriptionPlansLoading, selectSubscriptionPlans, selectSubscriptionPlansErrorMessage, selectUserActiveSubscriptions, selectIsUserSubscriptionsLoading } from '../../../../store/selectors/subscription-plans.selectors';
import { toSignal } from '@angular/core/rxjs-interop';
import { userSubscribeToPlan, loadUserActiveSubscriptions } from '../../../../store/actions/subscription-plans.actions';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { loadStripe } from '@stripe/stripe-js';
import { selectPacks } from '../../../../store/selectors/packs.selectors';
import { environment } from '../../../../../environments/environments';
import { CommonModule } from '@angular/common';
import { UserActiveSubscription } from '../../../../models/subscription';
import { ToastModule } from 'primeng/toast';
import { StripeService } from '../../../../services/stripe.service';

@Component({
  selector: 'app-subscriptions-profile',
  imports: [ButtonModule, TableModule, ToastModule, DialogModule, TagModule, CommonModule],
  templateUrl: './subscriptions-profile.component.html',
  styleUrl: './subscriptions-profile.component.scss'
})
export class SubscriptionsProfileComponent implements OnInit {
  constructor(private messageService: MessageService,
    private route: ActivatedRoute,
  ) { }
  private store = inject(Store);
  private stripeService = inject(StripeService);
  loadStripe = environment.loadStripe;
  visible: boolean = false;
  planChosen: any = null;
  loadingSubscriptionToPlan = signal<string | null>(null);
  userCredits = toSignal(this.store.select(selectUserCredits))
  listOfPlans = toSignal(this.store.select(selectSubscriptionPlans));
  listOfPacks = toSignal(this.store.select(selectPacks))
  loadingSubscribeToPlan = toSignal(this.store.select(selectIsSubscriptionPlansLoading))
  userActiveSubscriptions = toSignal(this.store.select(selectUserActiveSubscriptions));
  loadingUserSubscriptions = toSignal(this.store.select(selectIsUserSubscriptionsLoading));
  showConfirmDialog = false;
  isMobile = window.innerWidth < 768;
  showConfirmResiliationDialog = false;
  planToResiliate: any = null;

  ngOnInit() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user.user_id) {
      this.store.dispatch(loadUserActiveSubscriptions({ userId: user.user_id.toString() }));
    }
  }


  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  getSeverity(daysLeft: number): 'success' | 'info' | 'warn' | 'danger' {
    if (daysLeft > 30) return 'success';
    if (daysLeft > 10) return 'info';
    if (daysLeft > 3) return 'warn';
    return 'danger';
  }

  showDialog() {
    this.visible = true;
  }
  subscribeToPlan(plan: any) {
    console.log(plan);
    this.showConfirmDialog = true;
    this.planChosen = plan;
  }
  // confirmPurchase() {
  //   this.showConfirmDialog = false;
  //   this.loadingSubscriptionToPlan.set(this.planChosen.id);
  //   this.store.dispatch(userSubscribeToPlan({ planId: this.planChosen.id, userId: JSON.parse(localStorage.getItem('user') || '{}').user_id.toString() }));
  // }
  cancelSubscription(subscription: any) {
    console.log("resiliate", subscription);
    this.planToResiliate = subscription;
    this.showConfirmResiliationDialog = true;

  }
  confirmResiliation() {
    this.showConfirmResiliationDialog = false;
    const plan_id = this.planToResiliate.plan_id;
    const user_id = JSON.parse(localStorage.getItem('user') || '{}').user_id.toString();
    this.stripeService.resiliateSubscription(user_id, plan_id).subscribe({
      next: (res) => {
        console.log("resiliation success", res);
        this.messageService.add({ severity: 'success', summary: 'Résiliation réussie', detail: 'Votre abonnement a été résilié avec succès.' });
        this.store.dispatch(loadUserActiveSubscriptions({ userId: user_id }));
      },
      error: (err) => {
        console.error("resiliation error", err);

        this.messageService.add({ severity: 'error', summary: 'Erreur de résiliation', detail: 'Une erreur est survenue lors de la résiliation de votre abonnement. Veuillez réessayer plus tard.' });
      }   
    });
  }
  async confirmPurchase() {
    const plan = this.planChosen;
    console.log("active sub", this.userActiveSubscriptions());
    console.log('Plan chosen:', plan);
    this.showConfirmDialog = false;
    if (this.userActiveSubscriptions()?.some((sub: UserActiveSubscription) => sub.plan_id === plan.id)) {
      console.log('User already has an active subscription for this plan.');  
      console.log("the plan id", plan.id);
      this.messageService.add({ severity: 'info', summary: 'Subscription Active', detail: 'Vous avez déjà un abonnement actif pour ce plan.' });
      return;

    }
    const stripe = await this.stripePromise;
    const response = await fetch(environment.apiUrl + 'api/stripe/create-checkout-session-reccurent', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`
      },
      body: JSON.stringify({
        user_id: JSON.parse(localStorage.getItem('user') || '{}').user_id,
        plan_id: plan.id
      }),
    });
    const session = await response.json();
    if (!response.ok) {
      console.error('Error creating checkout session:', session);
      this.messageService.add({ severity: 'error', summary: 'Payment Error', detail: 'There was an error processing your payment. Please try again.' });
      return;
    }
    const result = await stripe?.redirectToCheckout({
      sessionId: session.sessionId,
    });
    // if (result?.error) {
    //   console.error(result.error.message);
    // }
  }
  stripePromise = loadStripe(this.loadStripe);
  async purchase_pack(pack: any) {

    const stripe = await this.stripePromise;
    const response = await fetch(environment.apiUrl + 'api/stripe/create-checkout-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`
      },
      body: JSON.stringify({
        name: pack.name,
        price: pack.price,
        jeton: pack.credits,
        user_id: JSON.parse(localStorage.getItem('user') || '{}').user_id,
        pack_id: pack.id
      }),
    });
    const session = await response.json();
    if (!response.ok) {
      console.error('Error creating checkout session:', session);
      this.messageService.add({ severity: 'error', summary: 'Payment Error', detail: 'There was an error processing your payment. Please try again.' });
      return;
    }
    const result = await stripe?.redirectToCheckout({
      sessionId: session.sessionId,
    });

    if (result?.error) {
      console.error(result.error.message);
    }
  }

  test = effect(() => {
    console.log(this.listOfPlans())
    if (!this.loadingSubscribeToPlan()) {
      this.loadingSubscriptionToPlan.set(null);
    }
  })

}
